import axiosInstance from './authService.js';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchUserStatus = async () => {
    try {
      const response = await axiosInstance.get(`${API_BASE_URL}/me/status/`);
      return response.data; // This will contain { username, email, is_premium, is_trial_active, days_left_in_trial, company_name, hasPendingPaymentProof }
    } catch (error) {
      console.error('Error fetching user status:', error);
      throw error;
    }
  };
  
export const fetchPaymentProofs = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL}/my-proofs/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching payment proofs:', error);
        throw error;
    }
};
  
  export const fetchSubscriptions = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL}/accounts/me/subscriptions/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching subscriptions:', error);
        throw error;
    }
};
